import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';
import { FC } from 'react';
const AiAlert: FC<AlertProps> = ({
  title = 'AI',
  icon = 'ai',
  description = 'This is just a message from our AI, but we are so glad you are here.',
  ...props
}) => {
  return (
    <Alert
      icon={icon}
      title={title}
      description={description}
      chipIntent={`ai`}
      intent={`ai`}
      {...props}
    />
  );
};
export default AiAlert;
